module.exports = __webpack_public_path__ + "static/media/leclerc7.ee29bc08.jpg";